import React from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import { injectIntl } from 'react-intl';
import treeChanges from 'tree-changes';

import { Card, Collapse } from 'antd';
import CriteriaForm from './CriteriaForm';
import ReportTable from './ReportTable';

import GdsRcptTrackingReportActions from '../../Stores/GdsRcptTrackingReport/Actions';

const { Panel } = Collapse;

class GdsRcptTrackingReportScreen extends React.PureComponent {
  componentDidMount() {
    const { curSiteFlowId, initGdsRcptTracking } = this.props;

    if (curSiteFlowId > 0) {
      initGdsRcptTracking();
    }
  }

  componentDidUpdate(prevProps) {
    const { curSiteFlowId, initGdsRcptTracking } = this.props;
    const { changed } = treeChanges(prevProps, this.props);

    if (changed('curSiteFlowId')) {
      if (curSiteFlowId > 0) {
        initGdsRcptTracking();
      }
    }
  }

  componentWillUnmount() {}

  render() {
    const { intl, match } = this.props;

    return (
      <Card title={intl.formatMessage({ id: 'goods_receipt_tracking_report' })}>
        <Collapse defaultActiveKey={['2']}>
          <Panel header={intl.formatMessage({ id: 'criteria' })} key="1">
            <CriteriaForm match={match} />
          </Panel>
          <Panel header={intl.formatMessage({ id: 'report' })} key="2">
            <ReportTable match={match} />
          </Panel>
        </Collapse>
      </Card>
    );
  }
}

GdsRcptTrackingReportScreen.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  intl: PropTypes.object,
  // eslint-disable-next-line react/forbid-prop-types
  match: PropTypes.object,

  initGdsRcptTracking: PropTypes.func,
  curSiteFlowId: PropTypes.number
};

GdsRcptTrackingReportScreen.defaultProps = {
  intl: {},
  match: {},

  initGdsRcptTracking: {},
  curSiteFlowId: 0
};

const mapStateToProps = state => ({
  curSiteFlowId: state.app.curSiteFlowId
});

const mapDispatchToProps = dispatch => ({
  initGdsRcptTracking: () =>
    dispatch(GdsRcptTrackingReportActions.gdsRcptTrackingReportInitGdsRcptTracking())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(GdsRcptTrackingReportScreen));
